<template>
  <div style="margin-top:20px;">
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'List Address'"
          :fields="fields"
          :items="items"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="true"
          :isLoading="isLoading"
          @addForm="addForm"
          @editForm="editForm"
          :withCard="false"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal title="Modal title" color="success" size="xl" :closeOnBackdrop="false" :show.sync="addButton">
      <template #header>
        <h6 class="modal-title">Add Form Address</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Title"
              invalid-feedback="title should be filled"
              required
              v-model="$v.addressForm.title.$model"
              :is-valid="!$v.addressForm.title.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CTextarea
              label="Address"
              invalid-feedback="address should be filled"
              required
              rows="4"
              v-model="$v.addressForm.address.$model"
              :is-valid="!$v.addressForm.address.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Recipient name"
              invalid-feedback="name should be filled"
              required
              v-model="$v.addressForm.recipient_name.$model"
              :is-valid="!$v.addressForm.recipient_name.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Recipient phone"
              invalid-feedback="phone should be filled"
              required
              v-model="$v.addressForm.recipient_phone.$model"
              :is-valid="!$v.addressForm.recipient_phone.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Latitude"
              invalid-feedback="latitude should be filled"
              required
              v-model="$v.addressForm.lat.$model"
              :is-valid="!$v.addressForm.lat.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Longitude"
              invalid-feedback="Longitude should be filled"
              required
              v-model="$v.addressForm.long.$model"
              :is-valid="!$v.addressForm.long.$invalid"
            />
          </CCol>
        </CRow>
         <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="province">Province</label>
              <model-select
                class="form-control"
                id="province"
                :options="provinceList"
                v-model="$v.addressForm.province.$model"
                :isError="$v.addressForm.province.$invalid"
                @input="filterRegency"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.province.$invalid"
                class="invalid-feedback-custom"
              >Province should be filled.</div>
            </div>
          </CCol> 
          <CCol sm="3">
            <div class="form-group">
              <label for="regency">Regency</label>
              <model-select
                class="form-control"
                id="regency"
                :options="regencyList"
                v-model="$v.addressForm.regencies.$model"
                :isError="$v.addressForm.regencies.$invalid"
                @input="filterDistrict"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.regencies.$invalid"
                class="invalid-feedback-custom"
              >Please select one</div>
            </div>
          </CCol> 
           <CCol sm="3">
            <div class="form-group">
              <label for="district">District</label>
              <model-select
                class="form-control"
                id="district"
                :options="districtList"
                @input="filterVillage"
                v-model="$v.addressForm.district.$model"
                :isError="$v.addressForm.district.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.district.$invalid"
                class="invalid-feedback-custom"
              >Please select one</div>
            </div>
          </CCol> 
           <CCol sm="3">
            <div class="form-group">
              <label for="village">Village</label>
              <model-select
                class="form-control"
                id="village"
                :options="villageList"
                v-model="$v.addressForm.villages.$model"
                :isError="$v.addressForm.villages.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.villages.$invalid"
                class="invalid-feedback-custom"
              >Please select one</div>
            </div>
          </CCol> 
        </CRow>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="primary_address">Primary</label>
              <model-select
                class="form-control"
                id="primary_address"
                :options="primary"
                v-model="$v.addressForm.primary.$model"
                :isError="$v.addressForm.primary.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.primary.$invalid"
                class="invalid-feedback-custom"
              >Primary Address should be filled.</div>
            </div>
          </CCol> 
          <CCol sm="3">
            <div class="form-group">
              <label for="acive_status">Active</label>
              <model-select
                class="form-control"
                id="active_status"
                :options="flag"
                v-model="$v.addressForm.flag.$model"
                :isError="$v.addressForm.flag.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.addressForm.flag.$invalid"
                class="invalid-feedback-custom"
              >Please select one</div>
            </div>
          </CCol> 
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.addressForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";

import { required } from "vuelidate/lib/validators";

export default {
  name: "Address",
  components: { GlobalTable, Loading },
  data() {
    return {
      addButton: false,
      isEdit: false,
      image: null,
      activeTab: 0,
      addressForm: tableInterfaces.users_address,
      checkedFlag: "Address",
      regencyList:[],
      districtList:[],
      villageList:[],
      isLoading: false,
      fields: [
        { key: "title", label: "Title" },
        { key: "address", label: "Address" },
        { key: "recipient_name", label: "Recipient name" },
        { key: "recipient_phone", label: "Recipient phone" },
        { key: "province_name", label: "Province" },
        { key: "regencies_name", label: "Regency" },
        { key: "district_name", label: "District" },
        { key: "villages_name", label: "Villages" },
        { key: "primary_name", label: "Primary" },
        { key: "flag_name", label: "Active" },
        { key: "action", _classes: "text-center action" },
      ],
      primary: [
        { value: "1", text: "Primary" },
        { value: "0", text: "Not Primary" },
      ],
      flag: [
        { value: "1", text: "Active" },
        { value: "2", text: "Not Active" },
      ],
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    iduser: {
      type: String,
      default: null,
    },
    provinceList:{
      type:[Array,Object],
      default: () => []
    }
  },
  validations: {
    addressForm: {
      user_code: {},
      title: {required},
      address: {required},
      recipient_name: {required},
      recipient_phone: {required},
      lat: {},
      long: {},
      province:{required},
      district:{required},
      regencies:{required},
      villages:{required},
      primary: {required},
      flag: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function () {
    },
    resetForm: function () {
      for (var i in tableInterfaces.users_address) {
        tableInterfaces.users_address[i] = null;
      }
      this.addressForm = tableInterfaces.users_address;
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.addressForm = item;
      this.callRegencies();
      this.callDistrict();
      this.callVillage();
      this.addButton = true;
      this.addressForm.id = item.id;
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    refreshData: function () {
      this.isLoading = true;
      this.axios.get("console/users/detail/" + this.iduser).then((response) => {
        if (response.data.status === 2000) {
          this.$emit('update:items', response.data.address);
          this.showInfoNotification({
            title: 'Get Address',
            message: response.data.message,
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      }).catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    submitForm: function (event) {
      event.preventDefault();
      this.addressForm.id_user = this.iduser;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.axios.put("console/user_address/update", this.addressForm).then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: 'Change Address',
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          }).catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          }).finally(() => {
            this.addButton = false;
            this.resetForm();
            this.refreshData();
          });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.axios.post("console/user_address/add", this.addressForm).then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: 'Add Address',
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          }).catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          }).finally(() => {
            this.addButton = false;
            this.resetForm();
            this.refreshData();
          });
        }
      }
    },
    filterRegency: function(){
      this.addressForm.regencies = null;
      this.addressForm.district = null;
      this.addressForm.villages = null;
      this.regencyList = [];
      this.districtList = [];
      this.villageList = [];
      this.axios.get("/console/dropdown/regency/" + this.addressForm.province)
      .then((response) => {
        this.regencyList = response.data.data;
      });
    },
    filterDistrict: function(){
      this.addressForm.district = null;
      this.addressForm.villages = null;
      this.districtList = [];
      this.villageList = [];
      this.axios.get("/console/dropdown/district/" + this.addressForm.regencies)
      .then((response) => {
        this.districtList = response.data.data;
      });
    },
    filterVillage: function(){
      this.addressForm.villages = null;
      this.villageList = [];
      this.axios.get("/console/dropdown/village/" + this.addressForm.district)
      .then((response) => {
        this.villageList = response.data.data;
      });
    },
    callRegencies: function(){
      this.axios.get("/console/dropdown/regency/" + this.addressForm.province)
      .then((response) => {
        this.regencyList = response.data.data;
      });
    },
    callDistrict: function(){
      this.axios.get("/console/dropdown/district/" + this.addressForm.regencies)
      .then((response) => {
        this.districtList = response.data.data;
      });
    },
    callVillage: function(){
      this.axios.get("/console/dropdown/village/" + this.addressForm.district)
      .then((response) => {
        this.villageList = response.data.data;
      });
    }
  },
  
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>